const HashtagService = (type) => {
	let parsed = null;

	switch (type) {
		case "GETALL": {
			parsed = { type: "GET", url: "/api/v0.1/feedback-hashtags/" };
			break;
		}

		default: {
			parsed = null;
			break;
		}
	}

	return parsed;
};

export default HashtagService;
